module.exports = __webpack_public_path__ + "img/gq.0a2610f9.png";